export default __webpack_public_path__ + "static/media/NH05.73dd7e3b.jpg";